import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HomePage from "../pages/home/Home.Page";
import LoginPage from "../pages/login/Login.Page";
import VersionPage from "../pages/version/Version.Page";
import PgeActivityPage from "../pages/pge_activity/PgeActivity.Page";
import PgeSkillsetManagerPage from "../pages/pge_skillset_manager/PgeSkillsetManager.Page";
import ContentEditor from "../components/ContentEditor";
import UsersPage from "../pages/users/Users.Page";
import PptActivityPage from "../pages/ppt_activity/Pptactivity.Page";
import PptModulesPage from "../pages/ppt_modules&subModules/PptModules.Page";
import TrainingModule from "../pages/training_modules&subModules/TrainingModule";
import TrainingActivity from "../pages/training_activity/TrainingActivity";
import FlnMaster from "../pages/fln_master/FlnMaster";
import Nsdc from "../pages/nsdc/Nsdc";
import Manage_Nsdc from "../pages/manage_nsdc/Manage_Nsdc";
import NsdcCert from "../pages/nsdccertificate/NsdcCert";
import EceActivityPage from "../pages/ece_activity/EceActivity.Page";
import EceSkillsetManagerPage from "../pages/ece_skillset_manager/EceSkillsetManager.Page";
import TeacherCategoryPage from "../pages/teacherCategory/TeacherCategory.Page";
import TeacherBaselinePage from "../pages/teacherBaseline/TeacherBaseline.Page";
import UserAssignmentPage from "../pages/user_assignment/UserAssignment.Page";
import Instruction from "../pages/instruction_master/Instruction";
import ExtraModulePage from "../pages/ExtraModule/ExtraModule.Page";
import ExtraTopicPage from "../pages/ExtraTopic/ExtraTopic.Page";
import ExtraAssignmentPage from "../pages/ExtraAssignment/ExtraAssignment.Page";
import ExtraPage from "../pages/ExtraModule/Extra.Page";
import ExtraQuizPage from "../pages/extra_quiz/ExtraQuiz.Page";
import AudioAssessmentPage from "../pages/AudioAssessment/AudioAssessment.Page";
import PasscodeManagerPage from "../pages/passcodemanager/PasscodeManager.Page";
import CommonMonthlyQuiz from "../pages/CommonMonthlyQuiz/CommonMonthlyQuiz";
import CommonQuizTopic from "../pages/CommonQuizTopic/CommonQuizTopic";
import TemplateMaster from "../pages/template_master";
import Ece from "../pages/template_master/modules/Ece";
import Pge from "../pages/template_master/modules/Pge";
import ExtraModules from "../pages/template_master/modules/ExtraModules";
import Ppt from "../pages/template_master/modules/Ppt";
import Training from "../pages/template_master/modules/Training";
import Demo from "../pages/template_master/modules/Demo";
import TemplateOne from "../pages/template_master/template_store/Template1";
import TemplateTwo from "../pages/template_master/template_store/Template2";
import DemoTemplate from "../pages/template_master/template_store/DemoTemplate";
import BlockPage from "../pages/BlocksDistricts/Blocks.Page";
import FlnActivity from "../pages/FlnActivity/FlnActivity";
import StudentAssessment from "../pages/StudentAssessment/StudentAssessment.Page";
import Pedagogy from "../pages/PedagogySection/Pedagogy.page";
import PedagogyModule from "../pages/Pedagogy_modules&Submodules/PedagogyModule.Page";
import StudentAssessmentQuiz from "../pages/StudentAssessmentQuiz/StudentAssessmentQuiz.Page";
import IntroQuiz from "../pages/IntroQuiz/IntroQuiz";
import EraseUserdata from "../pages/EraseUserdata/EraseUserdata.page";
import Maintainance from "../pages/MaintainancePage/Maintainance";
import Feedback from "../pages/Feedback/Feedback";
import Quiz from "../pages/quiz_template/Quiz";
import PasscodeStatus from "../pages/PasscodeStatus/PasscodeStatus.page";
import DashboardSliderImage from "../pages/DashboardSlider/DashboardSliderImage.page";
import FlnTopicsPage from "../pages/FlnTopics/FlnTopicsPage";
import FlnSkillsPage from "../pages/FlnSkill/FlnSkill.Page";
import AmazonPay from "../pages/AmazonPay/AmazonPay.Page";
import AmazonCreateVoucher from "../pages/AmazonPay/AmazonCreateVoucher";
import Faq from "../pages/Faq/FaqPage";
import FaqSection from "../pages/FaqSection/FaqSection";
import AudioLabeling from "../pages/AudioLabeling/AudioLabeling";
import UserSwap from "../pages/UserSwap/UserSwap";
import Templates from "../pages/templates";
import ListTemplates from "../pages/templates/children/ListTemplates";
import CreateTemplate from "../pages/templates/children/CreateTemplate";
import Mediaurl from "../pages/templates/children/Mediaurl";
import Threads from "../pages/threads";
import ListAllTemplates from "../pages/threads/children/ListAllTemplates";
import CreateThread from "../pages/threads/children/CreateThread";
import Prakasak from "../pages/Prakashak/prakasak";
import PrakasakData from "../pages/Prakashak/prakasakData";
import AppSession from "../pages/App Session/AppSession";
import TrainingExtraResources from "../pages/trainingExtraResource/TrainingExtraResources";
import { Version } from "../api/api";
import ServerStatus from "../pages/ServerStatus/serverStatus";
import {
  getUserAppSession,
  updateSyncAppSessionThunk,
} from "../pages/login/Login.Thunk";
import { logout } from "../pages/login/Login.Slice";
import Matching from "../pages/Interactive/Matching";
import GamifiedModule from "../pages/gamified_quiz/GamifiedModule.page";
import Server from "../pages/server_status/Server";
import UserLogs from "../pages/Prakashak/userLogs";
import UserAllocation from "../pages/UserAllocation/UserAllocation";
import PrakashakDistrict from "../pages/PrakashakDistrictwise/PrakashakDistrict";
import PrakashakStatics from "../pages/Prakashak-Statics/PrakashakStatics.page";
import EcePasswordManager from "../pages/EcPasswordManager/EcPasswordManager.Page";
import AmazonVoucherStatus from "../pages/AmazonPay/AmazonVoucherStatus";
import TopParent from "../pages/TopParent/TopParent";
import PerformanceCertificate from "../pages/PerformanceCertificate/PerformanceCertificate";
import TokenCode from "../pages/tokencode/TokenCode";
import ECstudentEdit from "../pages/ECstudentEdit/ECstudentEdit.page";
import { getDecryptedItem, setEncryptedItem } from "../utils/storageUtils";
import TeacherDataUpload from "../pages/TeachersDataUpload/TeachersDataUplaod";
import UploadBooks from "../pages/UploadBooks/uploadBooks";
import UserRegister from "../pages/UserRegister/UserRegister.page";
// import CreateThread from "../pages/threads/children/CreateThread";
// import ListAllTemplates from "../pages/threads/children/ListAllTemplates";
// import FlnSkillsPage from "../pages/FlnSkills/FlnSkillsPage";
// import Feedback from "../pages/Feedback/Feedback";
// import Feedback from "../pages/Feedback/Feedback";
// import EceActivityPage from "../pages/ece_activity/EceActivity.Page";
// import EceSkillsetManagerPage from "../pages/ece_skillset_manager/EceSkillsetManager.Page";
// import TeacherCategory from "../pages/teacherCategory/TeacherCategory.Page";

function AppRoute({ loggedin }) {
  const dispatch = useDispatch();
  const userType = getDecryptedItem("usertype");
  const userName = getDecryptedItem("username");
  const userId = getDecryptedItem("userid");
  const uniqueId = getDecryptedItem("uniqueId");

  // const handleSession = async () => {
  //   try {
  //     const params = {
  //       app: "mis",
  //       usertype: userType,
  //       userId: userId,
  //       deviceId: uniqueId,
  //     };
  //     const response = await dispatch(getUserAppSession(params));
  //     console.log(
  //       "getUserAppSession response:",
  //       response?.payload?.data[0]?.logout
  //     );
  //     if (response?.payload?.data[0]?.logout === true) {
  //       alert("Your session has ended. Please log in again.");
  //       const body = {
  //         userid: userId,
  //         app: "mis",
  //         appVersion: Version?.version,
  //       };
  //       console.log("body", body);
  //       const updateResponse = await updateSyncAppSessionThunk(body);
  //       console.log("updateLogoutSession response:", updateResponse);
  //       dispatch(logout());
  //     }
  //   } catch (err) {
  //     console.log("Error in handleSession:", err);
  //   }
  // };

  // useEffect(() => {
  //   // const intervalId = setInterval(() => {
  //   handleSession();
  //   // }, 10000); // 60000 milliseconds = 1 minute

  //   // Clear the interval when the component unmounts or when the dependencies change
  //   // return () => clearInterval(intervalId);
  // }, []);

  return (
    <Routes>
      {!loggedin && (
        <>
          <Route path="/login" element={<LoginPage />} />
        </>
      )}

      {loggedin && userType === "mis" && (
        <>
          <Route exact path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />

          {/* <Route exact path="/" element={<ServerStatus />} /> */}
          {/* <Route path="/home" element={<ServerStatus />} /> */}

          <Route path="/contenteditor" element={<ContentEditor />} />
          <Route path="/pgeactivity" element={<PgeActivityPage />} />
          <Route path="/nsdc" element={<Nsdc />} />
          <Route path="/manage_nsdc" element={<Manage_Nsdc />} />
          <Route path="/nsdccert" element={<NsdcCert />} />
          <Route
            path="/pgeskillsetmanager"
            element={<PgeSkillsetManagerPage />}
          />

          <Route path="/teacherbaseline" element={<TeacherBaselinePage />} />
          <Route path="/teachercategory" element={<TeacherCategoryPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/user-assignment" element={<UserAssignmentPage />} />
          <Route path="/ppt" element={<PptActivityPage />} />
          <Route path="/pptmodules&submodules" element={<PptModulesPage />} />
          <Route path="/gamified-module" element={<GamifiedModule />} />
          <Route path="/trainingmodule" element={<TrainingModule />} />
          <Route path="/trainingactivity" element={<TrainingActivity />} />
          <Route path="/flnmaster" element={<FlnMaster />} />

          <Route path="/manage_nsdc" element={<Manage_Nsdc />} />
          <Route path="/nsdccert" element={<NsdcCert />} />
          <Route path="/eceactivity" element={<EceActivityPage />} />
          <Route
            path="/eceskillsetmanager"
            element={<EceSkillsetManagerPage />}
          />
          <Route path="/instruction" element={<Instruction />} />
          <Route path="/extramodulepage" element={<ExtraModulePage />} />
          <Route path="/extrapage" element={<ExtraPage />} />
          <Route path="/extratopicpage" element={<ExtraTopicPage />} />
          <Route
            path="/extraassignmentpage"
            element={<ExtraAssignmentPage />}
          />

          <Route path="/extraquizpage" element={<ExtraQuizPage />} />
          <Route path="/blockspage" element={<BlockPage />} />

          <Route
            path="/audioassessmentpage"
            element={<AudioAssessmentPage />}
          />
          <Route path="/templatemaster" element={<TemplateMaster />} />
          <Route path="/templatemaster_ece" element={<Ece />} />
          <Route path="/templatemaster_pge" element={<Pge />} />
          <Route path="/templatemaster_ppt" element={<Ppt />} />
          <Route path="/templatemaster_training" element={<Training />} />
          <Route path="/templatemaster_extra" element={<ExtraModules />} />
          <Route path="/templatemaster_demo" element={<Demo />} />
          <Route path="/template1" element={<TemplateOne />} />
          <Route path="/template2" element={<TemplateTwo />} />
          <Route path="/demotemplate" element={<DemoTemplate />} />
          <Route path="/passcodemanager" element={<PasscodeManagerPage />} />
          <Route path="/commonmonthlyquiz" element={<CommonMonthlyQuiz />} />
          <Route path="/flnactivity" element={<FlnActivity />} />
          <Route path="/commonquiztopic" element={<CommonQuizTopic />} />
          <Route path="/flntopic" element={<FlnTopicsPage />} />
          <Route path="/flnskill" element={<FlnSkillsPage />} />

          <Route path="/introquiz" element={<IntroQuiz />} />
          <Route path="/studentassessment" element={<StudentAssessment />} />
          <Route
            path="/studentassessmentquiz"
            element={<StudentAssessmentQuiz />}
          />
          <Route path="/pedagogy" element={<Pedagogy />} />
          <Route path="/pedagogy-modules" element={<PedagogyModule />} />
          <Route path="/quiz-template" element={<Quiz />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/erase-userdata" element={<EraseUserdata />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/passcode-requests" element={<PasscodeStatus />} />
          <Route path="/dashboard_slider" element={<DashboardSliderImage />} />
          <Route path="/maintainance" element={<Maintainance />} />
          <Route path="/amazonpay" element={<AmazonPay />} />
          <Route
            path="/amazoncreatevoucher"
            element={<AmazonCreateVoucher />}
          />
          {/* <Route path="/thinkzoneservers" element={<ServerStatus />} /> */}

          {/* <Route path="/prakasak" element={<Prakasak />} /> */}

          <Route path="/faq" element={<Faq />} />
          <Route path="/faqsection" element={<FaqSection />} />
          <Route path="/audiolabeling" element={<AudioLabeling />} />
          <Route path="/userswap" element={<UserSwap />} />
          {/* <Route path="/create-thread" element={<CreateThread />} /> */}
          <Route
            path="/trainingextraresources"
            element={<TrainingExtraResources />}
          />
          {/* <Route path="/list-template" element={<ListAllTemplates />} /> */}
          <Route path="/templates" element={<Templates />} />
          <Route path="" element={<ListTemplates />} />
          <Route path="list-templates" element={<ListTemplates />} />
          <Route path="create-template" element={<CreateTemplate />} />
          <Route path="media-url" element={<Mediaurl />} />

          <Route path="/threads" element={<Threads />} />
          <Route path="" element={<ListAllTemplates />} />
          <Route path="list-all-templates" element={<ListAllTemplates />} />
          <Route path="create-thread" element={<CreateThread />} />
          <Route path="prakashak-district" element={<PrakashakDistrict />} />
          <Route path="uploadBooks" element={<UploadBooks />} />
          <Route path="/user-register" element={<UserRegister />} />
          <Route path="/student-register" element={<UserRegister />} />
        </>
      )}

      {loggedin && userType === "admin" && (
        <>
          <Route exact path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          {/* <Route exact path="/" element={<ServerStatus />} />
          <Route path="/home" element={<ServerStatus />} /> */}
          <Route path="/contenteditor" element={<ContentEditor />} />
          <Route path="/pgeactivity" element={<PgeActivityPage />} />
          <Route path="/nsdc" element={<Nsdc />} />
          <Route path="/manage_nsdc" element={<Manage_Nsdc />} />
          <Route path="/nsdccert" element={<NsdcCert />} />
          <Route
            path="/pgeskillsetmanager"
            element={<PgeSkillsetManagerPage />}
          />
          <Route path="/teacherbaseline" element={<TeacherBaselinePage />} />
          <Route path="/teachercategory" element={<TeacherCategoryPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/user-assignment" element={<UserAssignmentPage />} />
          <Route path="/ppt" element={<PptActivityPage />} />
          <Route path="/pptmodules&submodules" element={<PptModulesPage />} />
          <Route path="/trainingmodule" element={<TrainingModule />} />
          <Route path="/trainingactivity" element={<TrainingActivity />} />
          <Route path="/flnmaster" element={<FlnMaster />} />
          <Route path="/manage_nsdc" element={<Manage_Nsdc />} />
          <Route path="/nsdccert" element={<NsdcCert />} />
          <Route path="/eceactivity" element={<EceActivityPage />} />
          <Route
            path="/eceskillsetmanager"
            element={<EceSkillsetManagerPage />}
          />
          <Route path="/instruction" element={<Instruction />} />
          <Route path="/extramodulepage" element={<ExtraModulePage />} />
          <Route path="/extrapage" element={<ExtraPage />} />
          <Route path="/extratopicpage" element={<ExtraTopicPage />} />
          <Route
            path="/extraassignmentpage"
            element={<ExtraAssignmentPage />}
          />
          <Route path="/extraquizpage" element={<ExtraQuizPage />} />
          <Route path="/blockspage" element={<BlockPage />} />
          <Route
            path="/audioassessmentpage"
            element={<AudioAssessmentPage />}
          />
          <Route path="/templatemaster" element={<TemplateMaster />} />
          <Route path="/templatemaster_ece" element={<Ece />} />
          <Route path="/templatemaster_pge" element={<Pge />} />
          <Route path="/templatemaster_ppt" element={<Ppt />} />
          <Route path="/templatemaster_training" element={<Training />} />
          <Route path="/templatemaster_extra" element={<ExtraModules />} />
          <Route path="/templatemaster_demo" element={<Demo />} />
          <Route path="/template1" element={<TemplateOne />} />
          <Route path="/template2" element={<TemplateTwo />} />
          <Route path="/demotemplate" element={<DemoTemplate />} />
          <Route path="/passcodemanager" element={<PasscodeManagerPage />} />
          <Route path="/commonmonthlyquiz" element={<CommonMonthlyQuiz />} />
          <Route path="/flnactivity" element={<FlnActivity />} />
          <Route path="/commonquiztopic" element={<CommonQuizTopic />} />
          <Route path="/flntopic" element={<FlnTopicsPage />} />
          <Route path="/flnskill" element={<FlnSkillsPage />} />
          <Route path="/introquiz" element={<IntroQuiz />} />
          <Route path="/studentassessment" element={<StudentAssessment />} />
          <Route
            path="/studentassessmentquiz"
            element={<StudentAssessmentQuiz />}
          />
          <Route path="/pedagogy" element={<Pedagogy />} />
          <Route path="/pedagogy-modules" element={<PedagogyModule />} />
          <Route path="/quiz-template" element={<Quiz />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/erase-userdata" element={<EraseUserdata />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/passcode-requests" element={<PasscodeStatus />} />
          <Route path="/dashboard_slider" element={<DashboardSliderImage />} />
          <Route path="/maintainance" element={<Maintainance />} />
          <Route path="/amazonpay" element={<AmazonPay />} />
          <Route path="/amazonpaystatus" element={<AmazonVoucherStatus />} />
          {/* <Route path="/thinkzoneservers" element={<ServerStatus />} /> */}
          <Route
            path="/amazoncreatevoucher"
            element={<AmazonCreateVoucher />}
          />
          <Route path="/prakasak" element={<Prakasak />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/faqsection" element={<FaqSection />} />
          <Route path="/audiolabeling" element={<AudioLabeling />} />
          <Route path="/userswap" element={<UserSwap />} />
          <Route path="/app-session" element={<AppSession />} />
          {/* <Route path="/create-thread" element={<CreateThread />} /> */}
          <Route path="/gamified-module" element={<GamifiedModule />} />
          {/* <Route path="/list-template" element={<ListAllTemplates />} /> */}
          <Route path="/templates" element={<Templates />}>
            <Route path="" element={<ListTemplates />} />
            <Route path="list-templates" element={<ListTemplates />} />
            <Route path="create-template" element={<CreateTemplate />} />
            <Route path="media-url" element={<Mediaurl />} />
          </Route>
          <Route path="/threads" element={<Threads />} />
          <Route path="" element={<ListAllTemplates />} />
          <Route path="list-all-templates" element={<ListAllTemplates />} />
          <Route path="create-thread" element={<CreateThread />} />
          <Route
            path="/trainingextraresources"
            element={<TrainingExtraResources />}
          />
          <Route path="/prakasakData" element={<PrakasakData />} />
          <Route path="/match/:userId" element={<Matching />} />
          <Route path="userallocation" element={<UserAllocation />} />
          <Route path="topparent" element={<TopParent />} />
          <Route path="/prakashak-district" element={<PrakashakDistrict />} />
          <Route path="ece-password-manager" element={<EcePasswordManager />} />
          <Route path="ec-student-edit" element={<ECstudentEdit />} />
          <Route path="/prakashak-static-data" element={<PrakashakStatics />} />
          <Route path="uploadBooks" element={<UploadBooks />} />
          <Route path="topparent" element={<TopParent />} />
          <Route
            path="/PerformanceCertificate"
            element={<PerformanceCertificate />}
          />
          <Route path="tokencode" element={<TokenCode />} />
          <Route path="teachersDataUplaod" element={<TeacherDataUpload />} />
          <Route path="/user-register" element={<UserRegister />} />
          <Route path="/student-register" element={<UserRegister />} />
        </>
      )}

      {loggedin && userType === "prakashak" && (
        <>
          <Route path="/prakasakData" element={<PrakasakData />} />
          <Route path="/userLogs" element={<UserLogs />} />
          <Route path="/prakashak-static-data" element={<PrakashakStatics />} />
          <Route path="/home" element={<Prakasak />} />
          <Route path="/prakashak-district" element={<PrakashakDistrict />} />
          <Route path="topparent" element={<TopParent />} />
          <Route
            path="/PerformanceCertificate"
            element={<PerformanceCertificate />}
          />
        </>
      )}

      {loggedin && userType === "passcode" && (
        <>
          {/* <Route path="/home" element={<Prakasak />} /> */}
          {/* <Route path="/prakasakData" element={<PrakasakData />} /> */}
          <Route path="/passcodemanager" element={<PasscodeManagerPage />} />
          {/* <Route path="/userLogs" element={<UserLogs />} /> */}
          {/* <Route path="/" element={<Prakasak />} /> */}
          <Route path="/home" element={<PasscodeStatus />} />
          {/* <Route path="/prakasakData" element={<Prakasak />} /> */}
        </>
      )}

      <Route
        path="*"
        element={<Navigate to={loggedin ? "/home" : "/login"} />}
      />
    </Routes>
  );
}

export default AppRoute;
